import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { SharedService } from '../../core/services/shared.service';
import { SnackbarService } from '../../core/services/snackbar/snackbar.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { VehicleService } from '../../core/services/vehicle/vehicle.service';
import { OperatingAuthorityService } from '../../core/services/operatingAuthority/operating-authority.service';
import { select, Store } from '@ngrx/store';
import { companyStateData } from '../../state/selectors/companySelectors';
import { getUnviewedCount } from '../../state/actions/companyAction';

@Component({
  selector: 'app-side-nav',
  standalone: true,
  imports: [CommonModule, MatExpansionModule, MatTooltipModule],
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss',
})
export class SideNavComponent implements OnInit {
  activeParentName: string = '';
  unreadNotifications = 0;
  unreadComments = 0;

  companyItem = {
    title: 'Company',
    link: '/company-information',
    child: false,
  };
  driversItem = { title: 'Drivers', link: '/drivers', child: false };
  vehicleItem = { title: 'Vehicles', link: '/vehicles', child: false };
  OperatingAuthorityItem = {
    title: 'OperatingAuthorities',
    link: '/OperatingAuthorities',
    child: false,
  };
  OperatingAuthorityApplicationItem = {
    title: 'OperatingAuthorityApplication',
    link: '/OperatingAuthorityApplication',
    child: false,
  };
  helpItem = { title: 'Help', link: '/help', child: false };
  downloadItem = {
    title: 'Download',
    link: '/download-documents',
    child: false,
  };
  notificationsItem = {
    title: 'Notifications',
    link: '/notifications',
    child: false,
  };
  commentsItem = {
    title: 'Comments',
    link: '/comments',
    child: false,
  };

  sideNavVisible: boolean = true;

  constructor(
    private store: Store,
    private router: Router,
    private sharedService: SharedService,
    private snackBarService: SnackbarService,
    private vehicleService: VehicleService,
    private operatingAuthorityService: OperatingAuthorityService,
  ) {
    this.store.dispatch(getUnviewedCount());
    window.onpopstate = () => {
      this.setSelectedModule(location.href);
    };
    this.store.pipe(select(companyStateData)).subscribe((data: any) => {
      this.unreadNotifications =
        data?.unviewedCountData?.unviewedNotificationCount || 0;
      this.unreadComments = data?.unviewedCountData?.unviewedCommentCount || 0;
    });
  }

  setSelectedModule(url: string) {
    if (url.includes('/company-information')) {
      this.router.navigate(['/company-information']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.companyItem.title,
          navigate: this.companyItem.link,
        }),
      );
    } else if (url.includes('/drivers')) {
      this.router.navigate(['/drivers']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.driversItem.title,
          navigate: this.driversItem.link,
        }),
      );
    } else if (url.includes('/vehicles')) {
      this.router.navigate(['/vehicles']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.vehicleItem.title,
          navigate: this.vehicleItem.link,
        }),
      );
    } else if (url.includes('/OperatingAuthorities')) {
      this.router.navigate(['/OperatingAuthorities']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.OperatingAuthorityItem.title,
          navigate: this.OperatingAuthorityItem.link,
        }),
      );
    } else if (url.includes('/help')) {
      this.router.navigate(['/help']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.helpItem.title,
          navigate: this.helpItem.link,
        }),
      );
    } else if (url.includes('/OperatingAuthorityApplication')) {
      this.router.navigate(['/OperatingAuthorityApplication']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.OperatingAuthorityApplicationItem.title,
          navigate: this.OperatingAuthorityApplicationItem.link,
        }),
      );
    } else if (url.includes('/download-documents')) {
      this.router.navigate(['/download-documents']);
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: this.downloadItem.title,
          navigate: this.downloadItem.link,
        }),
      );
    }
  }

  navigate(item: any, parentData: any) {
    this.vehicleService.selectedVehicleDetails = null;
    this.snackBarService.close();
    if (item?.child) {
      this.activeParentName = parentData.title;
    } else {
      this.activeParentName = '';
    }
    localStorage.setItem(
      'selectedModule',
      JSON.stringify({
        name: item.title,
        navigate: item.link,
      }),
    );

    if (item.link === '/OperatingAuthorities') {
      this.operatingAuthorityService.selectedOAdata = null;
      this.operatingAuthorityService.permitTypeCode = null;
      this.router.navigate(['/OperatingAuthorities'], { replaceUrl: true });
    } else {
      this.router.navigate([item.link]);
    }
  }

  handleKeydown(event: KeyboardEvent, item: any) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.navigate(item, null);
    }
  }

  ngOnInit() {
    this.sharedService.sideNavVisible$.subscribe((visible) => {
      this.sideNavVisible = visible;
    });
    const postReloadRedirect = sessionStorage.getItem('postReloadRedirect');
    if (postReloadRedirect) {
      sessionStorage.removeItem('postReloadRedirect');
      this.router.navigateByUrl(postReloadRedirect, { replaceUrl: true });
      return;
    }
    const selectedModule: any = JSON.parse(
      localStorage.getItem('selectedModule') || '{}',
    );
    if (selectedModule && Object.keys(selectedModule).length > 0) {
      this.activeParentName = '';
      this.router?.navigate([selectedModule?.navigate]);
    } else {
      localStorage.setItem(
        'selectedModule',
        JSON.stringify({
          name: 'Company',
          navigate: './company-information',
        }),
      );
    }
  }

  isActive(route: string): boolean {
    return this.router.url.includes(route);
  }

  isTextTruncated(element: HTMLElement): boolean {
    return element && element.offsetWidth < element.scrollWidth;
  }
}
